import { useRef, useEffect } from 'react';

/**
 * Hook for auto-scrolling to bottom when dependencies change
 * Used for chat message lists
 *
 * @param {any[]} deps - Dependency array that triggers scroll (e.g., [messages])
 * @returns {React.RefObject} Ref to attach to scroll target element
 */
export function useAutoScrollToBottom(deps) {
  const scrollRef = useRef(null);

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, deps);

  return scrollRef;
}

export default useAutoScrollToBottom;
